export default __webpack_public_path__ + "static/media/bold.8c67ffdd.blob";